<style scoped>
.thin-border {
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 5px;
}
</style>

<template>
  <v-btn
    v-on:click.stop
    height=70
    text
    block
    :ripple=false
  >
    <v-row align=center>
      <v-col cols=2>
        <v-icon size=50>insert_drive_file</v-icon>
      </v-col>
      <v-col cols=2>
        {{this.file.name}}
      </v-col>

      <!--Spacer Column-->
      <v-col cols=6></v-col>

      <v-col cols=2>
        <v-btn icon>
          <v-icon color="red" v-on:click="onRemove(file)">remove_circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-btn>
</template>

<script>
export default {
  props: {
    file: File,
    onRemove: Function
  },
  methods: {
  },
  data: () => ({
  }),
};
</script>